module.exports = __webpack_public_path__ + "img/Eduzz-11-en.6cc2b587.png";